import React from "react";
import { useLocation } from "react-router-dom";
import TableTitle from "src/components/home/TableTitle";
import MoreButton from "src/components/button/MoreButton";
import MoreButton2 from "src/components/button/MoreButton2";
import StockTable from "src/components/table/StockTable";

interface StockBoardProps <T = {}> {
  contents: T[];
  isMore: boolean;
  handleLoadMore: () => Promise<void>;
}

const StockBoard: React.FC<StockBoardProps> = ({ contents, isMore, handleLoadMore }) => {
  const location = useLocation();
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  
  return (
    <div className={`w-100 py-4 col-12 col-lg ${isMobile?"":"px-3"}`}>
      <TableTitle 
      name="인기 종목"
      modalData={{
          title: "인기 종목",
          content: [
          "최근 24시간 기준 텔레그램 언급된 종목 랭킹"
          ]
      }} 
      type="/stock"
      />
      <StockTable
        contents={contents}
      />
      {location.pathname === "/" ?<MoreButton path="/stock" /> : isMore && <MoreButton2 onClick={handleLoadMore} />}
    </div>
  );
};

export default StockBoard;




